/**
 * Firebase client.
 *
 * The app reads Firestore directly rather than through an API function: with
 * security rules pinned to a single account there is nothing an API layer would
 * add except another thing to deploy. Rules live in `firestore.rules`.
 */

import { initializeApp } from 'firebase/app';
import { GoogleAuthProvider, getAuth, signInWithPopup, signOut } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string,
  appId: import.meta.env.VITE_FIREBASE_APP_ID as string,
};

export const app = initializeApp(config);
export const auth = getAuth(app);

/**
 * Named database, matching the collector. The default database in this project
 * serves other apps; netwatch keeps its own rules and lifecycle.
 */
export const firestore = getFirestore(app, import.meta.env.VITE_FIREBASE_DATABASE_ID || 'netmon');

export const signIn = () => signInWithPopup(auth, new GoogleAuthProvider());
export const signOutNow = () => signOut(auth);
